import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  noIndex?: boolean;
}

const BASE_URL = 'https://trouveunmediateur.fr';
const DEFAULT_OG_IMAGE = 'https://trouveunmediateur.fr/logo.png';

const SEO = ({
  title,
  description = "Trouvez des médiateurs de justice certifiés offrant des consultations ou partagez votre expertise pour aider ceux qui en ont besoin.",
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  noIndex = false,
}: SEOProps) => {
  const fullTitle = title 
    ? `${title} | Trouve un Médiateur` 
    : "Trouve un Médiateur - Médiateurs de Justice Certifiés en quelques minutes partout en France";
  
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1024" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Trouve un Médiateur" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* GEO - AI/LLM Discovery */}
      <meta name="citation_title" content={fullTitle} />
      <meta name="citation_public_url" content={canonicalUrl} />
      <meta name="citation_author" content="Trouve un Médiateur" />
    </Helmet>
  );
};

export default SEO;
